(() => {
  const STORAGE_KEY = 'popup-first-add-shown';

  const modal = document.getElementById('popup-modal');
  if (!modal) return;

  // Shown already — nothing to do
  if (localStorage.getItem(STORAGE_KEY)) return;

  const closeBtn = modal.querySelector('.gwp-modal__close');

  function openModal() {
    if (modal.open) return;
    localStorage.setItem(STORAGE_KEY, '1');
    modal.showModal();
  }

  function closeModal() {
    modal.close();
  }

  closeBtn?.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  modal.addEventListener('cancel', (e) => {
    e.preventDefault();
    closeModal();
  });

  // Track previous item count to detect 0 → 1 transition
  let prevItemCount = window.__popupInitialCartCount ?? 0;

  document.addEventListener('cart:update', (e) => {
    if (localStorage.getItem(STORAGE_KEY)) return;

    const itemCount =
      e.detail?.data?.itemCount ??
      e.detail?.itemCount ??
      null;

    if (itemCount === null) return;

    if (prevItemCount === 0 && itemCount > 0) {
      openModal();
    }

    prevItemCount = itemCount;
  });
})();
